// useRemoveUserFromOrg.ts

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { removeUserFromOrganization as removeUserFromOrganizationApi } from '../services/apiUsers.ts';
import { toast } from '../utils/sweetAlert.ts';

export function useRemoveUserFromOrg() {
  const queryClient = useQueryClient();

  const { isLoading: isEditing, mutate: removeUser } = useMutation({
    mutationFn: removeUserFromOrganizationApi,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['users'] });
      queryClient.invalidateQueries({ queryKey: ['organizations'] });
      toast('success', 'User removed from organization successfully!');
    },
    onError: (error: any) => {
      toast('error', `Something went wrong! ${error.message}`);
    },
  });

  return { isEditing, removeUser };
}
